import { Box, CardBody, Flex } from "@chakra-ui/react";
import { camelCase } from "lodash";
import { AutoFormSection } from "models/autoForm";
import { UseFormReturn } from "react-hook-form";
import { useRef } from "react";
import LoadingDots from "components/Loading";
import { CDS } from "design-system";
import { FloatingFieldSize } from "design-system/components/FloatingField/context";
import FormSection from "./FormSection";
import TransparentCard from "components/Card/TransparentCard";

interface DynamicFormProps {
  form: UseFormReturn<any>;
  sections: AutoFormSection[];
  isLoaded?: boolean;
  size?: FloatingFieldSize;
}

export default function DynamicForm({ form, sections, isLoaded = true, size }: DynamicFormProps) {
  const sectionRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});

  if (!isLoaded) {
    return (
      <Box mt="16">
        <LoadingDots />
      </Box>
    );
  }

  return (
    <Flex direction="column" mt="4">
      {sections.map((section) => {
        const sectionId = `section-${camelCase(section.title)}`;
        return (
          <Box
            key={section.title}
            id={sectionId}
            ref={(el) => {
              sectionRefs.current[sectionId] = el;
              return el;
            }}
          >
            <TransparentCard>
              <CardBody p="4" px="8">
                <CDS.Heading14 mb="2">{section.title}</CDS.Heading14>
                <FormSection section={section} form={form} size={size} />
              </CardBody>
            </TransparentCard>
          </Box>
        );
      })}
    </Flex>
  );
}
